import { SuperAdminConstants } from '../../../_constants';

const initialState = { addAnalyticsActiveBatchesLoading: true, data: '', error: false };

export function addAnalyticsActiveBatchesReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_ADD_ANALYTICS_ACTIVE_BATCHES:
            return {
                addAnalyticsActiveBatchesLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_ADD_ANALYTICS_ACTIVE_BATCHES:
            return {
                addAnalyticsActiveBatchesLoading: false,
                data: action.addAnalyticsActiveBatches,
                error: false
            };
        case SuperAdminConstants.ADD_ANALYTICS_ACTIVE_BATCHES_ERROR:
            return {
                addAnalyticsActiveBatchesLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/ManageBatches/addAnalyticsActiveBatches.reducer.js